import { baseTranslations } from "./translations-base";
import { euroTranslations } from "./translations-euro1";
import { euroTranslations2 } from "./translations-euro2";
import { globalTranslations } from "./translations-euro3";
import { pageTranslations } from "./translations-pages";
import { pricingTranslations } from "./translations-pricing";
import { servicesTranslations } from "./translations-services";
import { addonsTranslationsBatch2 } from "./translations-addons-batch2";
import { socialCalendarTranslations } from "./translations-social-calendar";
import { pluginIntegrationTranslations } from "./translations-plugin-integrations";
import { cookieAuditTranslations } from "./translations-cookie-audit";
import { revenueCalcTranslations } from "./translations-revenue-calc";
import { referralTranslations } from "./translations-referral";
import { serviceBenefitTranslations } from "./translations-service-benefits";
import { legalTranslations } from "./translations-legal";
import { pwaTranslations } from "./translations-pwa";
import { notifTranslations } from "./translations-notifications";
import { productPageTranslations } from "./translations-products";
import { marketingTranslations } from "./translations-marketing";
import { p0FeaturesTranslations } from "./translations-p0-features";
import { landingSeoTranslations } from "./translations-landing-seo";
import { studioTranslations } from "./translations-studio";
import { communityTranslations } from "./translations-community";
import { authExtrasTranslations } from "./translations-auth-extras";
import { agentOsTranslations } from "./translations-agent-os";

const merged = {
  ...baseTranslations,
  ...euroTranslations,
  ...euroTranslations2,
  ...globalTranslations,
};

// Merge page translations into each language
[pageTranslations, pricingTranslations, servicesTranslations, addonsTranslationsBatch2, socialCalendarTranslations, pluginIntegrationTranslations, cookieAuditTranslations, revenueCalcTranslations, referralTranslations, serviceBenefitTranslations, legalTranslations, pwaTranslations, notifTranslations, productPageTranslations, marketingTranslations, p0FeaturesTranslations, landingSeoTranslations, studioTranslations, communityTranslations, authExtrasTranslations, agentOsTranslations].forEach(dict => {
  Object.keys(dict).forEach(lang => {
    if (merged[lang]) {
      merged[lang] = { ...merged[lang], ...dict[lang] };
    } else {
      merged[lang] = { ...(dict.en || {}), ...dict[lang] };
    }
  });
});

export const translations = merged;
